import { datadogRum } from '@datadog/browser-rum';

const env = process.env.NODE_ENV || 'development';

const { DATADOG_API_KEY, NEXT_PUBLIC_APP_API_ENDPOINT, RELEASE_TAG } = process.env

datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APP_ID,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'hp-web',
    env: "prod",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
});